module.exports = __webpack_public_path__ + "media/images/athena-ebdd6438a1ca614c88125bea3689d53d.ico";